(function () {
  // Gör en horisontell slider oändligt loopande (mobil): klonar första och sista
  // bilden i varje ände och hoppar osynligt tillbaka när man passerar en klon.
  // På så vis flyttar varje pilklick exakt ett steg och bläddringen går runt
  // i all oändlighet åt båda hållen. Fungerar även med swipe.
  function setupInfiniteSlider(slider, prevBtn, nextBtn, itemSelector) {
    if (!slider) return;
    var items = slider.querySelectorAll(itemSelector);
    var count = items.length;
    if (count < 2) return;

    var mq = window.matchMedia('(max-width: 768px)');
    var built = false;
    var cur = 0;
    var scrollTimer = null;

    function w() { return slider.clientWidth || 1; }

    function jumpTo(i) {
      var prevBehavior = slider.style.scrollBehavior;
      slider.style.scrollBehavior = 'auto';
      slider.scrollLeft = i * w();
      slider.style.scrollBehavior = prevBehavior;
    }

    function slideTo(i) {
      slider.scrollTo({ left: i * w(), behavior: 'smooth' });
    }

    function onScroll() {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(slider.scrollLeft / w());
        if (i <= 0) { cur = count; jumpTo(count); }
        else if (i >= count + 1) { cur = 1; jumpTo(1); }
        else { cur = i; }
      }, 90);
    }

    function build() {
      if (built) return;
      built = true;
      var firstClone = items[0].cloneNode(true);
      var lastClone = items[count - 1].cloneNode(true);
      firstClone.classList.add('ws-clone');
      lastClone.classList.add('ws-clone');
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      slider.insertBefore(lastClone, items[0]);
      slider.appendChild(firstClone);
      cur = 1;
      jumpTo(1);
      requestAnimationFrame(function () { jumpTo(1); });
      slider.addEventListener('scroll', onScroll, { passive: true });
    }

    function destroy() {
      if (!built) return;
      built = false;
      slider.removeEventListener('scroll', onScroll);
      slider.querySelectorAll('.ws-clone').forEach(function (c) { c.parentNode && c.parentNode.removeChild(c); });
      jumpTo(0);
    }

    function go(dir) {
      if (!mq.matches) return;
      if (!built) build();
      cur = cur + dir;
      slideTo(cur);
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    if (mq.matches) build();
    var onMq = function () { if (mq.matches) build(); else destroy(); };
    if (typeof mq.addEventListener === 'function') mq.addEventListener('change', onMq);
    else if (typeof mq.addListener === 'function') mq.addListener(onMq);
  }

  function initGallery(root) {
    if (root.dataset.wsGalleryReady === 'true') return;
    root.dataset.wsGalleryReady = 'true';

    var zone = root.querySelector('[data-ws-zoom-zone]');
    var cursor = root.querySelector('[data-ws-zoom-cursor]');
    var dialog = root.querySelector('[data-ws-lightbox]');
    var scroll = root.querySelector('[data-ws-lightbox-scroll]');
    var openButtons = root.querySelectorAll('[data-ws-stack-open]');
    if (!dialog || !scroll || !openButtons.length) return;

    var cursorHome = cursor ? cursor.parentNode : null;
    var pointerDown = false;
    var pointerMoved = false;
    var startX = 0;
    var startY = 0;
    var zoneHover = false;
    var lightboxOpen = false;
    var desktopMq = window.matchMedia('(min-width: 769px)');

    function isDesktop() {
      return desktopMq.matches;
    }

    function moveCursor(clientX, clientY) {
      if (!cursor) return;
      cursor.style.left = clientX + 'px';
      cursor.style.top = clientY + 'px';
    }

    function updateCursor() {
      if (!cursor) return;
      if (!isDesktop()) {
        cursor.hidden = true;
        cursor.setAttribute('aria-hidden', 'true');
        return;
      }
      var show = lightboxOpen || zoneHover;
      cursor.hidden = !show;
      cursor.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    function bindCursorZone(el) {
      if (!el || !cursor) return;
      el.addEventListener('pointerenter', function (e) {
        moveCursor(e.clientX, e.clientY);
      });
      el.addEventListener('pointermove', function (e) {
        moveCursor(e.clientX, e.clientY);
      });
    }

    function scrollToSlide(index) {
      var slide = scroll.querySelector('[data-slide-index="' + index + '"]');
      if (slide) slide.scrollIntoView({ block: 'start', inline: 'nearest' });
    }

    function open(index) {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      lightboxOpen = true;
      if (cursor) dialog.appendChild(cursor);
      document.body.style.overflow = 'hidden';
      updateCursor();
      requestAnimationFrame(function () {
        scrollToSlide(index);
      });
    }

    function close() {
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      lightboxOpen = false;
      if (cursor && cursorHome) cursorHome.appendChild(cursor);
      document.body.style.overflow = '';
      updateCursor();
    }

    if (zone) {
      zone.addEventListener('pointerenter', function () {
        if (!isDesktop()) return;
        zoneHover = true;
        updateCursor();
      });
      zone.addEventListener('pointerleave', function () {
        if (!isDesktop()) return;
        zoneHover = false;
        updateCursor();
      });
      bindCursorZone(zone);
    }

    bindCursorZone(dialog);
    bindCursorZone(scroll);

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    });

    // Produktsidans mobil-slider: oändlig loop med pilar + swipe.
    var stackList = root.querySelector('.ws-stack__list');
    var stackPrev = root.querySelector('[data-ws-stack-prev]');
    var stackNext = root.querySelector('[data-ws-stack-next]');
    setupInfiniteSlider(stackList, stackPrev, stackNext, '.ws-stack__item');

    dialog.addEventListener('pointermove', function (e) {
      if (lightboxOpen) moveCursor(e.clientX, e.clientY);
    });

    dialog.addEventListener('pointerdown', function (e) {
      pointerDown = true;
      pointerMoved = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    dialog.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;
      if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) {
        pointerMoved = true;
      }
    });

    dialog.addEventListener('pointerup', function () {
      if (pointerDown && !pointerMoved) close();
      pointerDown = false;
      pointerMoved = false;
    });

    dialog.addEventListener('close', function () {
      lightboxOpen = false;
      if (cursor && cursorHome) cursorHome.appendChild(cursor);
      document.body.style.overflow = '';
      updateCursor();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });

    function onMqChange() {
      if (!isDesktop()) {
        zoneHover = false;
        if (lightboxOpen) close();
        updateCursor();
      }
    }
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', onMqChange);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(onMqChange);
    }
  }

  // Kategorikort på mobil: horisontell slider som bläddrar runt i all oändlighet
  // (pilar + swipe). Desktop använder hover-fade via CSS.
  function initHoverNav(wrap) {
    if (wrap.dataset.wsHoverReady === 'true') return;
    wrap.dataset.wsHoverReady = 'true';

    var slider = wrap.querySelector('.ws-hover');
    var prev = wrap.querySelector('[data-ws-hover-prev]');
    var next = wrap.querySelector('[data-ws-hover-next]');
    setupInfiniteSlider(slider, prev, next, '.ws-hover__img');
  }

  function initAll(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-ws-gallery]').forEach(initGallery);
    ctx.querySelectorAll('[data-ws-hover-nav]').forEach(initHoverNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
